/* Mochi Cloud - desktop gallery slider + thumbnail strip.
   Horizon re-renders <media-gallery> on every variant change, which wipes the
   thumbnail bar and the wiring. So this rebuilds itself whenever the gallery
   node or its track is replaced, instead of running once on load. */
(function () {
  var wiredTrack = null;
  var wiredFirstSrc = null;
  var wiredGal = null;

  /* ------------------------------------------------------------------ */
  /* Pillow-colour focus (Complete Set).                                  */
  /* A variant has one featured image and on the Set it is the comforter */
  /* photo, so picking a pillow colour re-rendered the gallery onto the   */
  /* same comforter shot and looked dead. When the Pillow Color row is    */
  /* what changed, jump the freshly-rendered gallery to the five-colour   */
  /* pillow image instead. Any other option change cancels the intent so */
  /* a fast comforter click after a pillow click lands on the comforter.  */
  /* ------------------------------------------------------------------ */
  var PILLOW_SHOT = /mochi-cloud-3-colors/;
  var wantPillow = false;

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('variant-picker input[type="radio"]')) return;
    wantPillow = (t.dataset.optionName === 'Pillow Color');
  }, true);

  function slideMatches(el) {
    var im = el.querySelector('img');
    return !!(im && PILLOW_SHOT.test(im.currentSrc || im.src || im.getAttribute('src') || ''));
  }

  function focusPillow(gal) {
    /* Both galleries exist in the DOM in grid mode (Horizon hides one per
       breakpoint), so move both rather than guess which is on screen. */
    var track = gal.querySelector('.media-gallery__grid');
    if (track) {
      var kids = [].slice.call(track.children);
      for (var i = 0; i < kids.length; i++) {
        if (slideMatches(kids[i])) {
          var sb = track.style.scrollBehavior;
          track.style.scrollBehavior = 'auto';
          track.scrollLeft = kids[i].offsetLeft - kids[0].offsetLeft;
          track.style.scrollBehavior = sb;
          break;
        }
      }
    }
    var ss = gal.querySelector('slideshow-component');
    if (ss) {
      var slides = [].slice.call(ss.querySelectorAll('slideshow-slide'));
      for (var j = 0; j < slides.length; j++) {
        if (slideMatches(slides[j])) {
          if (typeof ss.select === 'function') { ss.select(j, undefined, { animate: false }); }
          else { slides[j].scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'instant' }); }
          break;
        }
      }
    }
  }

  function build() {
    var gal = document.querySelector('media-gallery');
    if (!gal) return;
    var track = gal.querySelector('.media-gallery__grid');
    if (!track) return;

    var bar = gal.querySelector('.pd-thumbs');

    /* Picking a colour makes Horizon re-render the gallery with that variant's
       image sorted to the front. The slider keeps its old scroll offset, so the
       new lead image sits off-screen to the left and the picture appears not to
       change at all. Track the first slide's src and rewind when it moves. */
    var lead = track.children[0] && track.children[0].querySelector('img');
    var firstSrc = lead ? (lead.currentSrc || lead.src) : '';
    var isNew = (track !== wiredTrack) || (firstSrc !== wiredFirstSrc);
    if (!isNew && bar && bar.isConnected) return;

    var slides = [].slice.call(track.children);
    if (slides.length < 2) { if (bar) bar.remove(); wiredTrack = track; wiredFirstSrc = firstSrc; return; }

    if (bar) bar.remove();
    gal.classList.add('pd-gal');

    bar = document.createElement('div');
    bar.className = 'pd pd-thumbs';

    function sync() {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      [].forEach.call(bar.children, function (b, n) { b.classList.toggle('is-on', n === i); });
      var on = bar.children[i];
      if (on && on.scrollIntoView) {
        var l = on.offsetLeft - (bar.clientWidth - on.offsetWidth) / 2;
        bar.scrollTo({ left: Math.max(0, l), behavior: 'smooth' });
      }
    }

    slides.forEach(function (s, i) {
      var img = s.querySelector('img');
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Show image ' + (i + 1) + ' of ' + slides.length);
      if (img) {
        var t = document.createElement('img');
        t.src = img.currentSrc || img.src;
        t.alt = '';
        t.loading = 'lazy';
        b.appendChild(t);
      }
      b.addEventListener('click', function () {
        var prev = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = s.offsetLeft - slides[0].offsetLeft;
        track.style.scrollBehavior = prev;
        sync();
      });
      bar.appendChild(b);
    });

    gal.appendChild(bar);
    track.addEventListener('scroll', sync, { passive: true });

    if (isNew) {
      var sb = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = 0;
      track.style.scrollBehavior = sb;
    }

    sync();
    wiredTrack = track;
    wiredFirstSrc = firstSrc;
  }

  /* ------------------------------------------------------------------ */
  /* Size + care accordion, injected into the buy box under the variant  */
  /* picker. Apparel only - the bedding products share this template and */
  /* a chest-measurement chart would be nonsense on a comforter, so this */
  /* is gated on handle. Add handles here when new apparel is added.     */
  /* ------------------------------------------------------------------ */
  var APPAREL = ['cloud-travel-hoodie', 'cloud-lounge-set'];

  var SIZES = [
    ['S',   '32-35"', '81-89cm',   '44.1"', '112cm', '25.6"', '65cm'],
    ['M',   '35-38"', '89-96cm',   '45.7"', '116cm', '26.4"', '67cm'],
    ['L',   '38-41"', '96-104cm',  '47.2"', '120cm', '27.2"', '69cm'],
    ['XL',  '41-44"', '104-112cm', '48.8"', '124cm', '28.0"', '71cm'],
    ['2XL', '44-47"', '112-119cm', '51.2"', '130cm', '28.7"', '73cm'],
    ['3XL', '47-50"', '119-127cm', '53.5"', '136cm', '29.5"', '75cm'],
    ['4XL', '50-52"', '127-132cm', '55.1"', '140cm', '30.3"', '77cm']
  ];

  var CARE = [
    'Machine wash cold on a gentle cycle, inside out, with like colours.',
    'Tumble dry low, or hang it up to dry.',
    'Cool iron if you need to — keep the heat off the satin hood lining.',
    'No bleach, no dry cleaning.'
  ];

  var CSS = '' +
    '.mmc-acc{margin:16px 0 2px;border-top:1px solid color-mix(in srgb,currentColor 16%,transparent)}' +
    '.mmc-acc details{border-bottom:1px solid color-mix(in srgb,currentColor 16%,transparent)}' +
    '.mmc-acc summary{list-style:none;cursor:pointer;display:flex;align-items:center;justify-content:space-between;' +
      'gap:12px;padding:13px 2px;font-weight:600;font-size:.94rem;line-height:1.3}' +
    '.mmc-acc summary::-webkit-details-marker{display:none}' +
    '.mmc-acc summary i{width:9px;height:9px;flex:none;margin-right:4px;opacity:.5;' +
      'border-right:1.7px solid currentColor;border-bottom:1.7px solid currentColor;' +
      'transform:rotate(45deg) translate(-2px,-2px);transition:transform .2s}' +
    '.mmc-acc details[open] summary i{transform:rotate(-135deg) translate(-2px,-2px)}' +
    '.mmc-acc .mmc-body{padding:0 2px 18px}' +
    '.mmc-acc table{width:100%;border-collapse:collapse;font-size:.84rem}' +
    '.mmc-acc th,.mmc-acc td{text-align:left;padding:8px 10px 8px 0;vertical-align:top;' +
      'border-bottom:1px solid color-mix(in srgb,currentColor 12%,transparent)}' +
    '.mmc-acc thead th{font-size:.66rem;letter-spacing:.09em;text-transform:uppercase;opacity:.55;font-weight:700}' +
    '.mmc-acc tbody th{font-weight:700;width:46px;white-space:nowrap}' +
    '.mmc-acc tbody tr:last-child th,.mmc-acc tbody tr:last-child td{border-bottom:0}' +
    '.mmc-acc td b{font-weight:600;display:block}' +
    '.mmc-acc td span{display:block;opacity:.55;font-size:.78rem;margin-top:1px}' +
    '.mmc-acc p{margin:13px 0 0;font-size:.79rem;line-height:1.55;opacity:.62}' +
    '.mmc-acc ul{margin:2px 0 0;padding-left:17px;font-size:.86rem;line-height:1.7;opacity:.78}' +
    '@media(max-width:560px){.mmc-acc th,.mmc-acc td{padding-right:6px}.mmc-acc table{font-size:.79rem}}';

  function styleOnce() {
    if (document.getElementById('mmc-acc-css')) return;
    var s = document.createElement('style');
    s.id = 'mmc-acc-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function makeAccordion() {
    var wrap = document.createElement('div');
    wrap.className = 'mmc-acc';
    wrap.id = 'mmc-acc';

    var rows = SIZES.map(function (r) {
      return '<tr><th>' + r[0] + '</th>' +
             '<td><b>' + r[1] + '</b><span>' + r[2] + '</span></td>' +
             '<td><b>' + r[3] + '</b><span>' + r[4] + '</span></td>' +
             '<td><b>' + r[5] + '</b><span>' + r[6] + '</span></td></tr>';
    }).join('');

    wrap.innerHTML =
      '<details><summary><span>Size guide</span><i></i></summary><div class="mmc-body">' +
        '<table><thead><tr><th>Size</th><th>Your chest</th><th>Garment chest</th><th>Length</th></tr></thead>' +
        '<tbody>' + rows + '</tbody></table>' +
        '<p>Oversized fit. Measure around the fullest part of your chest and pick that row — the garment is cut roomy from there.</p>' +
        '<p>S = US 2–4 / UK 6–8 &nbsp;·&nbsp; M = US 6–8 / UK 10–12 &nbsp;·&nbsp; L = US 10–12 / UK 14–16 &nbsp;·&nbsp; XL = US 14–16 / UK 18–20 &nbsp;·&nbsp; 2XL = US 18–20 / UK 22–24 &nbsp;·&nbsp; 3XL = US 22–24 / UK 26–28 &nbsp;·&nbsp; 4XL = US 26–28 / UK 30–32</p>' +
        '<p>Garment measured flat and doubled — allow about 2cm either way. Between sizes? Take the smaller for the look in the photos, the larger for more room. 3XL and 4XL sit closer to a regular fit.</p>' +
      '</div></details>' +
      '<details><summary><span>Care</span><i></i></summary><div class="mmc-body">' +
        '<ul><li>' + CARE.join('</li><li>') + '</li></ul>' +
        '<p>Machine washable. Cold and gentle keeps the fleece from matting and the satin from snagging.</p>' +
      '</div></details>' +
      '<details><summary><span>Delivery &amp; returns</span><i></i></summary><div class="mmc-body">' +
        '<ul><li>Tracked delivery, arriving in 5 business days.</li>' +
        '<li>Tracking link by email as soon as it ships.</li>' +
        '<li>180 days to change your mind — send it back for a refund.</li></ul>' +
      '</div></details>';
    return wrap;
  }


  function placeAccordion() {
    var handle = (window.location.pathname.split('/products/')[1] || '').split(/[?#]/)[0];
    if (APPAREL.indexOf(handle) === -1) return;

    var existing = document.getElementById('mmc-acc');
    if (existing && existing.isConnected) return;
    if (existing) existing.remove();

    var anchor = document.querySelector('variant-picker[data-block-id*="offer_variants"]') ||
                 document.querySelector('[class*="__offer_benefits"]') ||
                 document.querySelector('[class*="__offer_sub"]');
    if (!anchor) return;

    styleOnce();
    anchor.insertAdjacentElement('afterend', makeAccordion());
  }

  function run() {
    build();
    placeAccordion();
    var gal = document.querySelector('media-gallery');
    if (gal && gal !== wiredGal) {
      wiredGal = gal;
      if (wantPillow) { wantPillow = false; focusPillow(gal); }
    }
  }

  /* ------------------------------------------------------------------ */
  /* Phone hero that shrinks as you scroll. mochi-mobile.css pins the      */
  /* gallery and reads --mm-hero for the card height; the wrapper's own    */
  /* height is fixed, so shrinking the card never shifts the page under    */
  /* the thumb. ~44% of the viewport at the top, ~27% once you're into     */
  /* the buy box, eased over the first 240px of scroll.                    */
  /* ------------------------------------------------------------------ */
  var heroMq = window.matchMedia('(max-width: 749px)');
  var heroRaf = 0;
  function heroApply() {
    heroRaf = 0;
    var root = document.documentElement;
    if (!heroMq.matches || !document.querySelector('.product-information__media')) {
      root.style.removeProperty('--mm-hero');
      return;
    }
    var vh = window.innerHeight || 700;
    var max = Math.min(vh * 0.44, 380);
    var min = Math.max(Math.min(vh * 0.27, 250), 180);
    var t = Math.min(1, Math.max(0, (window.scrollY || 0) / 240));
    t = 1 - (1 - t) * (1 - t); /* ease-out: most of the shrink happens early */
    root.style.setProperty('--mm-hero', Math.round(max - (max - min) * t) + 'px');
  }
  function heroTick() { if (!heroRaf) heroRaf = requestAnimationFrame(heroApply); }
  window.addEventListener('scroll', heroTick, { passive: true });
  window.addEventListener('resize', heroTick, { passive: true });
  heroApply();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var pending = null;
  new MutationObserver(function () {
    clearTimeout(pending);
    pending = setTimeout(run, 80);
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('pageshow', run);
  setTimeout(run, 900);
  setTimeout(run, 2000);
})();
